import isMobile from 'is-mobile';

export class PrintUtils {
  static openPDF = (data?: Blob) => {
    if (!data) return;
    return URL.createObjectURL(data);
  };

  static printPDF = (blob: Blob) => {
    const url = URL.createObjectURL(blob);

    if (isMobile()) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';

    document.body.appendChild(iframe);

    iframe.onload = () => {
      const win = iframe.contentWindow;
      if (!win) return;

      const cleanup = () => {
        window.removeEventListener('focus', cleanup);
        URL.revokeObjectURL(url);
        document.body.removeChild(iframe);
      };

      window.addEventListener('focus', cleanup, { once: true });

      win.focus();
      win.print();
    };

    iframe.src = url;
  };
}
